import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [performance, setPerformance] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfileAndPerformance = async () => {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      if (!userId) {
        setError("L'ID utilisateur est manquant. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      try {
        const profileResponse = await axios.get(`${API_BASE_URL}/api/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setProfile(profileResponse.data);

        const performanceResponse = await axios.get(
          `${API_BASE_URL}/api/auth/performance/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const processedPerformance = {};
        Object.entries(performanceResponse.data.performanceByTag).forEach(([tag, questions]) => {
          const totalQuestions = questions.length;
          const correctAnswers = questions.filter((q) => q.correct).length;
          const averageElo =
            totalQuestions > 0
              ? questions.reduce((sum, q) => sum + q.elo, 0) / totalQuestions
              : 0;

          const scoreFraction = correctAnswers / totalQuestions;

          const performanceElo = calculatePerformanceElo(scoreFraction, averageElo, totalQuestions);

          processedPerformance[tag] = {
            score: `${correctAnswers}/${totalQuestions}`,
            averageElo,
            performanceElo,
          };
        });

        setPerformance(processedPerformance);
      } catch (err) {
        setError(err.response?.data?.message || 'Erreur lors de la récupération des données');
      } finally {
        setLoading(false);
      }
    };

    fetchProfileAndPerformance();
  }, []);

  const calculatePerformanceElo = (scoreFraction, averageElo, totalQuestions) => {
    if (!averageElo) return 'N/A';

    let adjustedScoreFraction = scoreFraction;
    let suffix = '';

    if (scoreFraction === 1) {
      adjustedScoreFraction = (scoreFraction * totalQuestions - 0.5) / totalQuestions;
      suffix = '+';
    } else if (scoreFraction === 0) {
      adjustedScoreFraction = 0.5 / totalQuestions;
      suffix = '-';
    }

    const performanceDifference = -400 * Math.log10((1 - adjustedScoreFraction) / adjustedScoreFraction);
    const performanceElo = averageElo + performanceDifference;

    return `${Math.round(performanceElo)}${suffix}`;
  };

  if (loading) {
    return <p style={{ textAlign: 'center' }}>Chargement des données...</p>;
  }

  if (error) {
    return <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>;
  }

  if (!profile) {
    return <p style={{ textAlign: 'center' }}>Aucun profil disponible.</p>;
  }

  const { email, elo, RD } = profile;

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Mon Profil</h1>
      <p>Email : {email}</p>
      <p>Elo : {Math.round(elo)}</p>
      <p>RD : {Math.round(RD)}</p>

      <h2>Performances par Tag</h2>
      {Object.keys(performance).length > 0 ? (
        <table style={{ margin: '0 auto', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid black', padding: '5px' }}>Tag</th>
              <th style={{ border: '1px solid black', padding: '5px' }}>Score</th>
              <th style={{ border: '1px solid black', padding: '5px' }}>Moyenne Elo</th>
              <th style={{ border: '1px solid black', padding: '5px' }}>Performance Elo</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(performance).map(([tag, details]) => (
              <tr key={tag}>
                <td style={{ border: '1px solid black', padding: '5px' }}>{tag}</td>
                <td style={{ border: '1px solid black', padding: '5px' }}>{details.score}</td>
                <td style={{ border: '1px solid black', padding: '5px' }}>
                  {details.averageElo ? Math.round(details.averageElo) : 'N/A'}
                </td>
                <td style={{ border: '1px solid black', padding: '5px' }}>
                  {details.performanceElo}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Aucune performance disponible. Commencez un quiz pour générer vos scores !</p>
      )}
    </div>
  );
};

export default Profile;
